import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { IDX_SEARCH_URL } from '../../constants/site';

// Direct MLS search box. The IDX Addons live widget mounts once per page in
// #idx-widget-container (Jess's Active Listings section), so this box simply
// opens the Swell MLS portal search with the visitor's query.
export const IdxSearchTool = () => {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const target = query.trim() ? `${IDX_SEARCH_URL}#${encodeURIComponent(query)}` : IDX_SEARCH_URL;
    window.open(target, '_blank', 'noopener');
  };

  return (
    <form onSubmit={handleSubmit} data-testid="idx-search-tool" className="relative">
      <div className="flex items-center bg-sand-50 rounded-xl shadow-xl overflow-hidden">
        <div className="flex-1 flex items-center px-5 py-4">
          <Search className="w-6 h-6 text-[#143160] mr-3 flex-shrink-0" />
          <input
            type="text"
            placeholder="City, ZIP, or Address..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            aria-label="Search properties by city, ZIP, or address"
            data-testid="idx-search-input"
            className="w-full bg-transparent text-gray-800 placeholder-gray-500 text-lg font-medium focus:outline-none"
          />
        </div>
        <button
          type="submit"
          data-testid="idx-search-submit"
          className="m-2 px-8 py-3 bg-gradient-to-r from-gold-400 to-gold-500 hover:from-gold-500 hover:to-gold-600 text-[#143160] font-bold rounded-lg transition-all duration-300 hover:scale-105 shadow-lg"
        >
          Search
        </button>
      </div>
    </form>
  );
};
